const AUTH_LOOP_PATHS = new Set(['/login', '/logout'])

export function safeInternalRedirect(redirect: unknown): string | null {
  if (typeof redirect !== 'string') {
    return null
  }
  if (!redirect.startsWith('/') || redirect.startsWith('//')) {
    return null
  }

  // Strip the query before trailing slashes. `/` and `/?fbp=...` both become
  // an empty path: that is the post-login team resolver, not a destination.
  const path = (redirect.split(/[?#]/, 1)[0] ?? '').replace(/\/+$/, '').toLowerCase()
  if (path === '' || AUTH_LOOP_PATHS.has(path)) {
    return null
  }

  return redirect
}
